import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { DiretorClinicoService } from '@/core/api/sicom-api/servicos/pessoa-fisica/diretor-clinico/diretor-clinico.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { DiretorClinicoRequest, DiretorClinicoResponse } from '@/core/api/sicom-api/servicos/pessoa-fisica/diretor-clinico/diretor-clinico.model';

@Injectable({ providedIn: 'root' })
export class DiretorClinicoServicosService {
    constructor(
        private api: DiretorClinicoService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: DiretorClinicoRequest, context?: HttpContext): Observable<DiretorClinicoResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
